import { ImageName } from "@mcleod/images";
import { Component, Image, Label, PanelProps } from "@mcleod/components";
import { AbstractDisplayPanelSelector } from "./AbstractDisplayPanelSelector";

export class ImageSelector extends AbstractDisplayPanelSelector {
    constructor(props?: Partial<PanelProps>) {
        super(props);
    }

    protected override getTitle(): string {
        return "Select Image";
    }

    protected override getValidationMessage(): string {
        return "Select an image.";
    }

    protected override discoverItemNames(): string[] {
        return Object.keys(ImageName).filter(value => {
            return !value.startsWith("designer_") && !value.startsWith("component_") && !value.startsWith("utility_");
        }).sort((a, b) => a.localeCompare(b));
    }

    protected override getSingleItemPanelComponents(imageName: ImageName): Component[] {
        const image = new Image({
            name: imageName,
            width: 64,
            height: 64,
            padding: 6
        });
        const label = new Label({ text: imageName, wrap: true });
        return [image, label];
    }
}
